import React, { ReactElement } from 'react';

import { HeaderImagePropsType } from '../../types';

const Premium = ({ url, altText }: HeaderImagePropsType) => {
  return <img data-testid="Premium__Logo" className="sm-enterprise-thank-you__logo" src={url} alt={altText || ''} />;
};

export default Premium;
